<!--
  국기 한 장. 이모지 대신 번들된 SVG 를 쓴다 (Windows 에 국기 글리프가 없어 'KR' 로 보이던 문제).
  해당 나라 SVG 가 없으면 ISO 두 글자 배지로 떨어진다 — 빈칸이 생기지 않는다.
-->
<template>
    <img
        v-if="url"
        :src="url"
        :alt="alt || ''"
        :aria-hidden="alt ? undefined : 'true'"
        class="shrink-0 rounded-[2px] object-cover ring-1 ring-black/10 dark:ring-white/15"
        :class="sizeClass"
        loading="lazy"
        decoding="async"
    />
    <span
        v-else
        class="shrink-0 inline-flex items-center justify-center rounded-[2px] bg-gray-100 dark:bg-gray-700 text-[10px] font-semibold leading-none text-gray-500 dark:text-gray-300"
        :class="sizeClass"
        :aria-hidden="alt ? undefined : 'true'"
        :aria-label="alt || undefined"
    >{{ badge }}</span>
</template>

<script setup>
import { computed } from 'vue';
import { countryFlagUrl } from '@/utils/countryFlags';

const props = defineProps({
    /** ISO 3166-1 alpha-2 (kr, KR 모두 허용) */
    code: { type: String, default: '' },
    /** 비우면 장식으로 간주해 스크린리더에서 숨긴다 */
    alt: { type: String, default: '' },
    /** 4:3 비율 유지 — 쓰는 쪽에서 덮어쓸 수 있다 */
    sizeClass: { type: String, default: 'w-6 h-[18px]' },
});

const url = computed(() => countryFlagUrl(props.code));
const badge = computed(() => (props.code || '').toUpperCase().slice(0, 2) || '?');
</script>
